@import (reference) '../../../constants/spacing.module.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.non-wallet-activation-modal {
  width: 560px;
}

.arrow-right {
  width: 12px;
  margin-left: 8px;
  margin-bottom: -2px;
}

.modal-body {
  padding: @space-16;
  font-size: 14px;
  line-height: 21px;
  min-height: 248px;
}

.error-banner {
  margin-bottom: @space-16;
}

.body-message {
  margin-top: @space-16;
}

.new-monthly-subscription {
  color: @onboarding-page--text-color;
}

.price-container {
  display: flex;
  align-items: center;
  margin: @space-16 0;
  font-size: 32px;
}

.old-price {
  text-decoration-line: line-through;
  color: var(--default--background-color--15);
  margin-right: @space-8;
}

.new-price {
  color: @onboarding-page--text-color;
}

.loading-indicator {
  min-height: 248px;
}

.footer-button {
  padding: 0 @space-16;
}
